<template>
  <v-container fluid pa-2>
    <v-col justify-center>
      <v-card class="mt-2 pb-0" style="border-radius: 5px">
        <!-- Toolbar -->
        <v-toolbar dense text id="toolbar">
          <v-row id="layoutToolbar" :style="[
            this.$i2kFunctions.isSmartphone()
              ? {
                'margin-right': '0px',
                'margin-left': '0px',
                'padding-right': '0px',
                'padding-left': '0px',
              }
              : {},
          ]">
            <!-- pulsante indietro -->
            <span id="pulsanteIndietro" :class="[this.$i2kFunctions.isSmartphone() ? 'btnTollbar' : '']">
              <v-tooltip v-if="getPagePreve == '/preventivo'" top>
                <template v-slot:activator="{ on }">
                  <v-btn color="black" v-on="on" icon v-on:click="prevPage">
                    <v-icon>navigate_before</v-icon>
                  </v-btn>
                </template>
                <span>Indietro</span>
              </v-tooltip>
            </span>

            <v-spacer></v-spacer>
            <span id="titoloPreventivatore">
              {{ this.$i2kFunctions.isSmartphone() ? "" : "PREVENTIVATORE - " }}
              Collezione SPEEDY
            </span>
            <v-spacer></v-spacer>
            <div id="containerPulsanti">
              <!-- Stampa -->
              <span :class="[this.$i2kFunctions.isSmartphone() ? 'btnTollbar' : '']">
                <v-tooltip v-if="getPagePreve == '/preventivo'" top>
                  <template v-slot:activator="{ on }">
                    <v-btn color="black" v-on="on" icon text v-on:click="stampaOrdine()">
                      <v-icon>print</v-icon>
                    </v-btn>
                  </template>
                  <span>Stampa</span>
                </v-tooltip>
              </span>

              <!-- Ricarica Dati -->
              <span :class="[this.$i2kFunctions.isSmartphone() ? 'btnTollbar' : '']">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn color="black" v-on="on" icon @click="refresh()">
                      <v-icon>refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>Ricarica dati</span>
                </v-tooltip>
              </span>

              <!-- Impostazioni -->
              <span :class="[this.$i2kFunctions.isSmartphone() ? 'btnTollbar' : '']">
                <v-menu ref="menuOpen" v-model="menuOpen" bottom left offset-x :close-on-click="true"
                  :close-on-content-click="true">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" color="black" icon text @click="GetMaggiorazioni()">
                      <v-icon>settings</v-icon>
                    </v-btn>
                  </template>

                  <v-card class="mx-auto" width="180px">
                    <v-menu bottom offset-y :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="ma-2 pa-2" v-bind="attrs" v-on="on" style="border-radius: 5px">
                          <v-icon>keyboard_arrow_down</v-icon>
                          Maggiorazioni
                        </v-btn>
                      </template>

                      <v-list dense style="max-width: 100%">
                        <v-list-item>
                          <v-list-item-title style="max-width: 50%" class="titolo">
                            Magg. Netta
                          </v-list-item-title>
                          <v-list-item-action style="max-width: 50%" class="action">
                            <v-text-field append-icon="euro_symbol" hide-details style="width: 100%"
                              v-model="MaggNetta">
                            </v-text-field>
                          </v-list-item-action>
                        </v-list-item>
                        <v-divider></v-divider>

                        <v-list-item>
                          <v-list-item-title style="max-width: 50%" class="titolo">
                            Magg. Perc
                          </v-list-item-title>
                          <v-list-item-action style="max-width: 50%" class="action">
                            <v-text-field append-icon="percent" hide-details v-model="MaggPerc">
                            </v-text-field>
                          </v-list-item-action>
                        </v-list-item>
                        <v-divider></v-divider>

                        <v-list-item>
                          <v-list-item-title style="max-width: 50%" class="titolo">
                            Sconto
                          </v-list-item-title>
                          <v-list-item-action style="max-width: 50%" class="action">
                            <v-text-field append-icon="percent" hide-details v-model="Sconto">
                            </v-text-field>
                          </v-list-item-action>
                        </v-list-item>
                        <v-divider></v-divider>

                        <v-btn class="pa-0 ml-2 mt-2" color="#ECCD20" @click="SalvaMaggiorazioni()"
                          v-on:click="menuOpen = false">
                          Salva
                        </v-btn>
                      </v-list>
                    </v-menu>
                    <v-btn v-if="getPagePreve == '/preventivo' &&
            this.$i2kFunctions.isSmartphone()
            " style="
                        border-radius: 5px;
                        width: 92%;
                        font-size: 90%;
                        padding-left: 0px;
                        padding-right: 0px;
                      " v-on:click="eliminaPreventivo()">
                      <v-icon> delete </v-icon>
                      Elimina preventivo
                    </v-btn>
                    <v-btn class="ma-2 pa-2" style="
                        border-radius: 5px;
                        width: 92%;
                        padding-left: 0px;
                        padding-right: 0px;
                      " @click="caricaFile()" v-on:click="menuOpen = false">
                      <v-icon> cloud_upload </v-icon>
                      Carica file
                    </v-btn>
                    <v-btn class="ma-2 pa-2" style="
                        border-radius: 5px;
                        width: 92%;
                        padding-left: 0px;
                        padding-right: 0px;
                      " @click="ricaricaPagina()" v-on:click="menuOpen = false">
                      <v-icon> refresh </v-icon>
                      Ricarica pagina
                    </v-btn>
                  </v-card>
                </v-menu>
              </span>
            </div>
          </v-row>
        </v-toolbar>
      </v-card>
    </v-col>

    <FilePreventivi :dialog="dialogUpload" @chiudiDialogFile="chiudiDialogFile"></FilePreventivi>
  </v-container>
</template>

<script>
import FilePreventivi from "@/components/dialog/preventivi/FilePreventivi.vue";

import {
  stampa_Preventivo,
  set_maggiorazioni,
  get_maggiorazioni,
  del_preventivo,
} from "@/api/api.preventivi.js";

export default {
  components: {
    FilePreventivi,
  },

  data: () => ({
    currentPage: "",
    MaggNetta: 0,
    MaggPerc: 0,
    Sconto: 0,

    menuOpen: false,

    dialogUpload: false,
  }),

  methods: {
    prevPage() {
      this.$router.push({
        path: "/preventivi",
      });
    },

    async SalvaMaggiorazioni() {
      let user = await this.$store.dispatch("user/userInfo");
      let par = {};
      if (this.$store.getters["app/getPagePreve"] == "/preventivi")
        par = {
          Utente: user.data.Utente,
          Email: user.data.EMail,
          IdPrev: -1,
          Sconto: this.Sconto,
          MaggPerc: this.MaggPerc,
          MaggNetta: this.MaggNetta,
        };
      else if (this.$store.getters["app/getPagePreve"] == "/preventivo")
        par = {
          Utente: user.data.Utente,
          Email: user.data.EMail,
          IdPrev: this.getNumPreve(),
          Sconto: this.Sconto,
          MaggPerc: this.MaggPerc,
          MaggNetta: this.MaggNetta,
        };
      let res = await set_maggiorazioni(par);
      if (res.data == "OK") {
        this.$toast.info("Maggiorazioni salvate");
        this.refresh();
      } else this.$toast.warning("Impossibile salvare le maggiorazioni");
    },

    async GetMaggiorazioni() {
      let user = await this.$store.dispatch("user/userInfo");
      let par = {};
      if (this.$store.getters["app/getPagePreve"] == "/preventivi")
        par = {
          Utente: user.data.Utente,
          Email: user.data.EMail,
          IdPrev: -1,
        };
      else if (this.$store.getters["app/getPagePreve"] == "/preventivo")
        par = {
          Utente: user.data.Utente,
          Email: user.data.EMail,
          IdPrev: this.getNumPreve(),
        };
      else return;
      let res = await get_maggiorazioni(par);
      if (res.data != null) {
        this.Sconto = res.data.Sconto;
        this.MaggNetta = res.data.MaggNetta;
        this.MaggPerc = res.data.MaggPerc;
      }
      //this.maggiorazioni = res.data;
    },

    async stampaOrdine() {
      let res = await stampa_Preventivo(this.getNumPreve());
      this.$i2kFunctions.createBlobPdf(res.data);
    },

    getNumPreve() {
      return this.$store.getters["app/getNumPreve"];
    },

    async eliminaPreventivo() {
      let confirm = await this.$root.$confirm(
        "Elimina",
        "Attenzione! Questa operazione eliminerà tutti i dati del preventivo corrente. Vuoi continuare?"
      );
      if (!confirm) return;
      // Attesa
      this.$root.$wait.open();
      let res = await del_preventivo(this.getNumPreve());
      // Pulizia
      if (res.data == "OK") {
        this.$toast.warning("Preventivo eliminato");
      }
      this.$root.$wait.close();
      this.$router.push({ path: "/preventivi" });
    },

    refresh() {
      this.$store.commit("app/SET_REFRESHDATI", true);
    },

    ricaricaPagina() {
      window.location.reload();
    },

    caricaFile() {
      this.$root.$wait.open();
      this.dialogUpload = true;
      this.$root.$wait.close();
    },

    chiudiDialogFile() {
      this.dialogUpload = false;
    },
  },

  mounted() {
    this.GetMaggiorazioni();
  },

  computed: {
    getPagePreve: function () {
      return this.$store.getters["app/getPagePreve"];
    },

    userSwitch: function () {
      return this.$store.getters["user/getUserSwitch"];
    },
  },

  watch: {
    $route(to, from) {
      //serve per capire da che pagina parto a che pagina arrivo
      this.$store.commit("app/SET_PAGEPREVE", to.path);
      this.GetMaggiorazioni();
    },

    userSwitch() {
      this.GetMaggiorazioni();
    },
  },
};
</script>

<style scoped src="../../assets/styles/preventivo.css"></style>